import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';

const signEula = (
  payload: {
    marketingMailList?: boolean;
    useMailList?: boolean;
  },
  { rootState, request }: EffectParams
) =>
  request({
    service: '/api/v1-preview/auth/eula/sign',
    method: 'POST',
    body: { useMailList: select.account.getEulaMarketingEnabled(rootState), ...payload }
  });

export default signEula;
